// ==================== HITÉRA — MOCK DATA ====================
// NOTE: All data below is MOCKED for the frontend teaser.
// It will be replaced by real backend APIs after approval.

export const LOGO_URL = "https://customer-assets-4nw71qhi.emergentagent.net/job_a2d73918-608d-4a92-9186-fcfbb626092e/artifacts/lbq6y0g3_WhatsApp%20Image%202026-08-21%20at%2018.02.17.jpeg";

// -------------------- HERO SLIDES --------------------
export const heroSlides = [
  {
    id: "h1",
    image: "https://images.unsplash.com/photo-1756483509164-e9e652cb51bb?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
    eyebrow: "The Resort Edit | SS'25",
    title: "Sun-Kissed Reverie",
    subtitle: "Where heritage craft meets effortless coastal glamour.",
    cta: "Discover The Collection",
    link: "/shop/indo-western-dresses",
  },
  {
    id: "h2",
    image: "https://images.unsplash.com/photo-1784854491938-02f3c181cc87?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
    eyebrow: "Signature Couture",
    title: "The Art of Occasion",
    subtitle: "Hand-embroidered gowns crafted for moments that matter.",
    cta: "Explore Gowns",
    link: "/shop/gowns",
  },
  {
    id: "h3",
    image: "https://images.pexels.com/photos/24784277/pexels-photo-24784277.jpeg?auto=compress&cs=tinysrgb&w=2000",
    eyebrow: "Timeless Drapes",
    title: "Modern Heirlooms",
    subtitle: "Indo-western sarees reimagined for the contemporary muse.",
    cta: "Shop Sarees",
    link: "/shop/indo-western-sarees",
  },
];

// -------------------- CATEGORIES --------------------
export const categories = [
  { slug: "indo-western-dresses", name: "Indo-Western Dresses", tagline: "Dresses & Jumpsuits", image: "https://images.unsplash.com/photo-1732709470611-670308da8c5e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { slug: "gowns", name: "Gowns", tagline: "Evening & Occasion", image: "https://images.pexels.com/photos/36747258/pexels-photo-36747258.jpeg?auto=compress&cs=tinysrgb&w=900" },
  { slug: "indo-western-sarees", name: "Indo-Western Sarees", tagline: "Sarees & Drapes", image: "https://images.unsplash.com/photo-1610189026297-df356264479c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { slug: "ready-to-wear", name: "Ready To Wear", tagline: "Everyday Luxe", image: "https://images.unsplash.com/photo-1769063382706-8156b3b33eac?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
];

export const categoryMap = categories.reduce((a, c) => { a[c.slug] = c; return a; }, {});

// -------------------- PRODUCTS --------------------
const P = (id, name, category, price, originalPrice, images, opts = {}) => ({
  id, name, category, price, originalPrice, images,
  colors: opts.colors || ["Gold", "Ivory"],
  sizes: opts.sizes || ["XS", "S", "M", "L", "XL"],
  fabric: opts.fabric || "Hand-woven Silk",
  description: opts.description || "A meticulously crafted piece featuring intricate hand embroidery, celebrating heritage artistry with a modern silhouette. Each garment is made-to-order by our master karigars.",
  stock: opts.stock ?? 8,
  isNew: opts.isNew || false,
  readyToShip: opts.readyToShip || false,
  color: opts.color || "Burgundy",
});

export const products = [
  P("HD-1001", "Marisa Draped Chiffon Gown", "gowns", 4390, 4890, [
    "https://images.unsplash.com/photo-1568252542512-9fe8fe9c87bb?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.pexels.com/photos/36747258/pexels-photo-36747258.jpeg?auto=compress&cs=tinysrgb&w=900",
  ], { color: "Burgundy", colors: ["Burgundy", "Wine"], fabric: "Silk Chiffon", isNew: true, readyToShip: true, stock: 6 }),
  P("HD-1002", "Noir Sculpted Evening Gown", "gowns", 5120, null, [
    "https://images.unsplash.com/photo-1568251188392-ae32f898cb3b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.unsplash.com/photo-1784833066649-7833eec50138?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  ], { color: "Black", colors: ["Black", "Midnight"], fabric: "Structured Crepe", stock: 4 }),
  P("HD-1003", "Aurelia Pearl-Kissed Gown", "gowns", 6230, null, [
    "https://images.unsplash.com/photo-1783368241380-48c25bb7be1a?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.pexels.com/photos/5185592/pexels-photo-5185592.jpeg?auto=compress&cs=tinysrgb&w=900",
  ], { color: "Ivory", colors: ["Ivory", "Champagne"], fabric: "Embellished Tulle", isNew: true, stock: 3 }),
  P("HD-1004", "Rosé Petal Ball Gown", "gowns", 4890, null, [
    "https://images.pexels.com/photos/31604282/pexels-photo-31604282.jpeg?auto=compress&cs=tinysrgb&w=900",
    "https://images.unsplash.com/photo-1610312774212-6bde94e8c0b0?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  ], { color: "Blush", colors: ["Blush", "Rose"], fabric: "Organza", readyToShip: true, stock: 5 }),

  P("HD-2001", "Serene Ivory Slip Dress", "indo-western-dresses", 1890, 2190, [
    "https://images.unsplash.com/photo-1571924848943-25c2c95bbb4b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.unsplash.com/photo-1610312774212-6bde94e8c0b0?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  ], { color: "Ivory", colors: ["Ivory", "Pearl"], fabric: "Satin Georgette", isNew: true, readyToShip: true, stock: 12 }),
  P("HD-2002", "Coastal Muse Draped Dress", "indo-western-dresses", 2240, null, [
    "https://images.unsplash.com/photo-1732709470611-670308da8c5e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.pexels.com/photos/13031581/pexels-photo-13031581.jpeg?auto=compress&cs=tinysrgb&w=900",
  ], { color: "Sand", colors: ["Sand", "Gold"], fabric: "Crepe Silk", stock: 9 }),
  P("HD-2003", "Riviera Column Dress", "indo-western-dresses", 2710, null, [
    "https://images.unsplash.com/photo-1784833066649-7833eec50138?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.unsplash.com/photo-1568252542512-9fe8fe9c87bb?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  ], { color: "Gold", colors: ["Gold", "Bronze"], fabric: "Metallic Lamé", isNew: true, stock: 7 }),
  P("HD-2004", "Palma Resort Jumpsuit", "indo-western-dresses", 1990, 2390, [
    "https://images.pexels.com/photos/5185592/pexels-photo-5185592.jpeg?auto=compress&cs=tinysrgb&w=900",
    "https://images.unsplash.com/photo-1783368241380-48c25bb7be1a?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  ], { color: "White", colors: ["White", "Ivory"], fabric: "Linen Blend", readyToShip: true, stock: 10 }),

  P("HD-3001", "Amethyst Handloom Saree", "indo-western-sarees", 2710, null, [
    "https://images.unsplash.com/photo-1610189026297-df356264479c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.unsplash.com/photo-1610189012906-4c0aa9b9781e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  ], { color: "Purple", colors: ["Purple", "Plum"], fabric: "Handloom Silk", sizes: ["One Size"], isNew: true, stock: 6 }),
  P("HD-3002", "Azure Gota-Patti Saree", "indo-western-sarees", 3120, 3620, [
    "https://images.unsplash.com/photo-1610189012906-4c0aa9b9781e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.unsplash.com/photo-1610189026297-df356264479c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  ], { color: "Blue", colors: ["Blue", "Saffron"], fabric: "Gota-Patti Silk", sizes: ["One Size"], stock: 5 }),
  P("HD-3003", "Emerald Draped Saree Gown", "indo-western-sarees", 3890, null, [
    "https://images.pexels.com/photos/1655844/pexels-photo-1655844.jpeg?auto=compress&cs=tinysrgb&w=900",
    "https://images.unsplash.com/photo-1610189026297-df356264479c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  ], { color: "Emerald", colors: ["Emerald", "Forest"], fabric: "Embroidered Silk", sizes: ["S", "M", "L"], isNew: true, readyToShip: true, stock: 4 }),

  P("HD-4001", "Meher Chikankari Kurta Set", "ready-to-wear", 890, 1090, [
    "https://images.unsplash.com/photo-1769063382706-8156b3b33eac?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.pexels.com/photos/7326221/pexels-photo-7326221.jpeg?auto=compress&cs=tinysrgb&w=900",
  ], { color: "Ivory", colors: ["Ivory", "Mint"], fabric: "Cotton Chikankari", readyToShip: true, stock: 18 }),
  P("HD-4002", "Saanjh Everyday Co-ord", "ready-to-wear", 740, null, [
    "https://images.pexels.com/photos/7326221/pexels-photo-7326221.jpeg?auto=compress&cs=tinysrgb&w=900",
    "https://images.pexels.com/photos/20158862/pexels-photo-20158862.jpeg?auto=compress&cs=tinysrgb&w=900",
  ], { color: "Beige", colors: ["Beige", "Olive"], fabric: "Linen", readyToShip: true, stock: 15 }),
  P("HD-4003", "Noor Printed Tunic Set", "ready-to-wear", 690, 820, [
    "https://images.pexels.com/photos/20158862/pexels-photo-20158862.jpeg?auto=compress&cs=tinysrgb&w=900",
    "https://images.unsplash.com/photo-1769063382706-8156b3b33eac?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  ], { color: "Coral", colors: ["Coral", "Ivory"], fabric: "Mulmul Cotton", readyToShip: true, isNew: true, stock: 20 }),

];

export const getProduct = (id) => products.find((p) => p.id === id);
export const getByCategory = (slug) => products.filter((p) => p.category === slug);

// -------------------- SPOTLIGHT / EDITS --------------------
export const spotlight = [
  { id: "s1", label: "Timeless Burgundy", link: "/shop/gowns", image: "https://images.unsplash.com/photo-1568252542512-9fe8fe9c87bb?crop=entropy&cs=srgb&fm=jpg&q=85&w=700" },
  { id: "s2", label: "The Resort Edit", link: "/shop/indo-western-dresses", image: "https://images.pexels.com/photos/13031581/pexels-photo-13031581.jpeg?auto=compress&cs=tinysrgb&w=700" },
  { id: "s4", label: "Heirloom Drapes", link: "/shop/indo-western-sarees", image: "https://images.pexels.com/photos/1655844/pexels-photo-1655844.jpeg?auto=compress&cs=tinysrgb&w=700" },
];

// -------------------- EXPLORE --------------------
export const explore = [
  { id: "e1", label: "In The Press", image: "https://images.unsplash.com/photo-1631549423034-ceb712f24ab2?crop=entropy&cs=srgb&fm=jpg&q=85&w=700" },
  { id: "e2", label: "The Runway", image: "https://images.unsplash.com/photo-1610047614256-023d7c028d0b?crop=entropy&cs=srgb&fm=jpg&q=85&w=700" },
  { id: "e3", label: "Sustaining Crafts", image: "https://images.unsplash.com/photo-1610047614301-13c63f00c032?crop=entropy&cs=srgb&fm=jpg&q=85&w=700" },
];

// -------------------- ADMIN MOCK: ORDERS --------------------
export const mockOrders = [
  { id: "HIT-90142", customer: "Ananya Rao", email: "ananya@example.com", date: "2025-07-12", total: 4390, status: "Processing", items: 1 },
  { id: "HIT-90141", customer: "Meera Kapoor", email: "meera@example.com", date: "2025-07-11", total: 2830, status: "Shipped", items: 2 },
  { id: "HIT-90140", customer: "Zoya Sheikh", email: "zoya@example.com", date: "2025-07-10", total: 6230, status: "Delivered", items: 1 },
  { id: "HIT-90139", customer: "Ishita Menon", email: "ishita@example.com", date: "2025-07-09", total: 1230, status: "Delivered", items: 3 },
  { id: "HIT-90138", customer: "Sara Khanna", email: "sara@example.com", date: "2025-07-08", total: 3890, status: "Cancelled", items: 1 },
];

// -------------------- FOOTER --------------------
export const footerLinks = {
  shop: ["Indo-Western Dresses", "Gowns", "Indo-Western Sarees", "Ready To Wear"],
  house: ["Our Story"],
  help: ["Contact Us", "Shipping & Returns", "Size Guide", "Book Appointment", "FAQs"],
};
